import { Table, Thead, Tbody, Tr, Th, Td } from '@chakra-ui/react';
import formatCurrency from '../../utility/formatCurrency';
import convertTimestampToDate from '../../utility/convertTimestampToDate';
import { Bar } from 'react-chartjs-2';
import { Box } from '@chakra-ui/react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const CashflowChart = ({ cashflowStatement, currency }) => {

    const years = cashflowStatement.map((statement, index) => statement.date );
    const freeCashflows = cashflowStatement.map((statement, index) => statement.freeCashFlow );

    const data = {
        labels: years,
        datasets: [
            {
                label: 'Free Cashflow',
                data: freeCashflows,
                backgroundColor: 'rgba(75, 192, 192, 0.6)',
                borderColor: 'rgba(75, 192, 192, 1)',
                borderWidth: 1,
            },
        ],
    };

    const options = {
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    callback: function (value) {
                        return formatCurrency(value, currency);
                    },
                },
            },
        },
    };

    return (
        <Box width="100%" height="400px">
            <Bar data={data} options={options} />
        </Box>
    );
}

export default CashflowChart;